export const autosize = () => {
	const elem = {};
	const init = selector => {
		const textarea = document.querySelector(selector);
		if (!textarea) {
			return;
		}
		textarea.style.position = 'relative';
		textarea.style.resize = 'none';
		textarea.style.overflow = 'hidden';

		const hiddenDiv = document.createElement('div');
		for (let i = 0; i < textarea.classList.length; i++) {
			hiddenDiv.classList.add(textarea.classList[i]);
		}
		hiddenDiv.style.visibility = 'hidden';
		hiddenDiv.style.position = 'absolute';
		hiddenDiv.style.top = '0px';
		hiddenDiv.style.left = '0px';
		hiddenDiv.style.height = 'auto';
		textarea.parentNode.appendChild(hiddenDiv);

		let cnt = textarea.value;
		cnt = cnt.replace(/\n/g, '<br>');
		hiddenDiv.innerHTML = cnt + '<br class="lbr">';
		textarea.style.height = hiddenDiv.clientHeight + 'px';

		textarea.onkeyup = e => {
			let content = e.target.value;
			content = content.replace(/\n/g, '<br>');
			hiddenDiv.innerHTML = content + '<br class="lbr">';

			if (hiddenDiv.clientHeight > 200) {
				e.target.style.height = hiddenDiv.clientHeight + 'px';
			}
			else {
				e.target.style.height = '200px';
			}
		};
	};
	elem.init = init;
	return elem;
};



// WEBPACK FOOTER //
// ./app/scripts/autosize.js